import clsx from "clsx";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type IconSizeType = "xs" | "sm" | "md" | "lg" | "xl";
export type IconCursorType = "pointer" | "default" | "inherit";

// These classes, controlled via 'cursor' prop need to be written in full to
// prevent them from being removed during optimization step:
// cursor-pointer cursor-default

export interface IconProps {
  icon: string;
  size?: IconSizeType;
  action?: () => void;
  dataTestId?: string;
  extraClasses?: string;
  cursor?: IconCursorType;
  title?: string;
}

const getIconSize = (size: IconSizeType) => {
  switch (size) {
    case "xs":
      return "text-xs";
    case "sm":
      return "text-base";
    case "md":
      return "text-xl";
    case "lg":
      return "text-2xl";
    case "xl":
      return "text-3xl";
  }
};

export const Icon = forwardRef<HTMLDivElement, IconProps>(
  ({ icon, action, dataTestId, title, extraClasses = "", size = "md", cursor = "default", ...rest }, forwaredRef) => {
    return (
      <i
        data-testid={dataTestId}
        ref={forwaredRef}
        onClick={action}
        className={clsx(twMerge(icon, getIconSize(size), `cursor-${cursor}`, "leading-none", extraClasses))}
        title={title}
        {...rest}
      />
    );
  }
);
Icon.displayName = "Icon";
